export const englishData = [
  {
    premiumTitle: "Premium Features",
    title1: "Master Your Knowledge",
    title2: "with PRO",
    subtitle:
      "Has contributed to the success of over 5 lakh students and has established trust",
    btnText: "Get PRO",
    features: [
      { text: "Full Access to all papers", highlight: true },
      { text: "Model Papers Included", highlight: true },
      { text: "100% Ad-Free Learning Experience", highlight: true },
      {
        text: "Explain Answer Lessons Unlocked (Sinhala only)",
        highlight: true,
      },
      {
        text: "Recorded Video Lessons Unlocked (Sinhala only)",
        highlight: true,
      },
      { text: "Learn Anytime, Anywhere at Your Convenience", highlight: true },
    ],

    paymentTitle: "Upgrade your experience today.",
    paymentSubtitle: "Transparent pricing, total security.",
    paymentPoints: [
      "One-Time Payment – No recurring charges or surprise renewals.",
      "4 Months of Full Validity – Enjoy 120 days of uninterrupted premium access.",
      "100% Secure Checkout – Your transaction is protected by industry-leading SSL encryption.",
      "Privacy Guaranteed – We value your data; your card details are never stored on our servers.",
      "Instant Activation – Get all Pro features delivered to your account immediately after payment.",
    ],
  },
];

export const sinhalaData = [
  {
    premiumTitle: "ප්‍රිමියම් පහසුකම්",
    title1: "රියදුරු විභාගයයි පුහුණුවයි",
    title2: "දෙකම ගොඩයන්න ",
    subtitle:
      "ලක්ශ 5කට අධික සිසුන්ගේ සමත්විම සදහා දායකත්වය ලබා දී විශ්වාසය තහවුරු කර ඇත",
    btnText: "Pro ලබා ගන්න",
    features: [
      { text: "සියලුම ප්‍රශ්න පත්‍ර සඳහා සම්පූර්ණ ප්‍රවේශය", highlight: true },
      {
        text: "මාදිලි ප්‍රශ්න පත්‍ර (Model Papers) ලබාගත හැක",
        highlight: true,
      },
      { text: "සම්පූර්ණයෙන්ම දැන්වීම් රහිත ඉගෙනීම", highlight: true },
      {
        text: "පිළිතුරු පැහැදිලි කිරීමේ පාඩම් ලබාගත හැක (සිංහලෙන් පමණි)",
        highlight: true,
      },
      {
        text: "පටිගත කළ වීඩියෝ පාඩම් ලබාගත හැක (සිංහලෙන් පමණි)",
        highlight: true,
      },
      { text: "ඔබට පහසු වේලාවක ඕනෑම වේලාවක අධ්‍යයනය කරන්න", highlight: true },
    ],

    paymentTitle: "වඩාත් ඉහළ අත්දැකීමක් සඳහා අදම සම්බන්ධ වන්න.",
    paymentSubtitle: "විනිවිදභාවය සහ උපරිම ආරක්ෂාව සමඟින්.",
    paymentPoints: [
      "එක් වරක් පමණක් ගෙවන්න (One-time Payment) – කිසිදු අමතර මාසික ගාස්තුවක් හෝ සැඟවුණු රීචාජ් කිරීම් නොමැත.",
      "මාස 4 ක වලංගු කාලය – දින 120 ක් පුරා බාධාවකින් තොරව සියලුම Premium පහසුකම් භුක්ති විඳින්න.",
      "100% සුරක්ෂිත ගෙවීම් – ඔබගේ ගෙවීම් කටයුතු නවීනතම SSL තාක්ෂණය ඔස්සේ පූර්ණ ආරක්ෂිතව සිදු කෙරේ.",
      "පෞද්ගලිකත්වය සහ ආරක්ෂාව – ඔබගේ බැංකු කාඩ්පත් දත්ත අපගේ පද්ධතියේ සුරැකිව තබා නොගන්නා (Never Save) බැවින් ඔබ වඩාත් සුරක්ෂිතයි.",
      "ක්ෂණික සක්‍රිය වීම – ගෙවීම් අවසන් වූ සැණින් සියලුම Pro පහසුකම් ඔබගේ ගිණුමට එක් වේ.",
    ],
  },
];

export const tamilData = [
  {
    title1: "PRO மூலம் உங்கள் அறிவை",
    title2: "மாஸ்டர் செய்யுங்கள்",
    subtitle:
      "5 லட்சத்திற்கும் மேற்பட்ட மாணவர்களின் வெற்றிக்கு பங்களித்துள்ளது மற்றும் நம்பிக்கையை நிலைநாட்டியுள்ளது.",
    premiumTitle: "பிரீமியம் அம்சங்கள்",
    btnText: "புரோவைப் பெறுங்கள்",
    features: [
      { text: "அனைத்து ஆவணங்களுக்கும் முழு அணுகல்", highlight: true },
      {
        text: "மாதிரி வினாத்தாள்கள் (Model Papers) கிடைக்கும்",
        highlight: true,
      },
      { text: "முழுமையான விளம்பரமற்ற கற்றல் அனுபவம்", highlight: true },
      {
        text: "விளக்கமான பதில் பாடங்கள் திறக்கப்படும் (சிங்களம் மட்டும்)",
        highlight: true,
      },
      {
        text: "பதிவு செய்யப்பட்ட வீடியோ பாடங்கள் திறக்கப்படும் (சிங்களம் மட்டும்)",
        highlight: true,
      },
      {
        text: "உங்களுக்கு வசதியான நேரத்தில் எப்போது வேண்டுமானாலும் கற்றுக்கொள்ளலாம்",
        highlight: true,
      },
    ],

    paymentTitle:
      "வெளிப்படைத்தன்மை மற்றும் அதிகபட்ச பாதுகாப்புடன் சிறந்த அனுபவத்திற்கு இன்றே சேருங்கள்.",
    paymentSubtitle: "",
    paymentPoints: [
      "ஒருமுறை மட்டுமே பணம் செலுத்துதல் (One-time Payment) – எவ்வித மறைமுகக் கட்டணங்களோ அல்லது தானாகப் புதுப்பிக்கப்படும் சந்தாக்களோ இல்லை.",
      "4 மாத கால செல்லுபடி – 120 நாட்களுக்கு எவ்விதத் தடையுமின்றி அனைத்து பிரீமியம் வசதிகளையும் அனுபவிக்கலாம்.",
      "100% பாதுகாப்பான பணப்பரிமாற்றம் – உங்கள் பணம் செலுத்துதல் நவீன SSL குறியாக்க முறையின் மூலம் முழுமையாகப் பாதுகாக்கப்படுகிறது.",
      "தனியுரிமைப் பாதுகாப்பு – உங்கள் வங்கி அட்டை விவரங்கள் (Card Details) எமது அமைப்பில் சேமிக்கப்பட மாட்டாது, எனவே நீங்கள் அச்சமின்றிப் பயன்படுத்தலாம்.",
      "உடனடிச் செயலாக்கம் (Instant Activation) – பணம் செலுத்திய உடனே அனைத்து Pro வசதிகளும் உங்கள் கணக்கில் சேர்க்கப்படும்.",
    ],
  },
];


export const englishDatapro = [{
  proWhyTitle: "Why Go Pro?",
  proWhyList: [
    "You can get the complete knowledge required for the driving exam.",
    "Contributed to the success of 5 lakh+ students.",
    "Selected as the number one app on Android and iOS.",
    "Thousands of positive user reviews.",
  ],
}]
export const sinhalaDatapro = [{
  proWhyTitle: "PRO ලබා ගැනීමේ වටිනාකම",
  proWhyList: [
    "රියදුරු විභාගය සදහා අවශ්‍ය සම්පුර්ණ දැනුම ලබා ගත හැක.",
    "ලක්ෂ 5කට අදික සිසුන්ගේ සමත්වීම සදහා දායකත්වය ලබා දී ඇත.",
    "Android සහ iOS හි අංක එක app ලෙස තෝරා පත්වීම.",
    "දහස් ගණනක් ධනාත්මක පරිශීලක ප්‍රතිචාර.",
  ],
}]

export const tamilDatapro = [{
  proWhyTitle: "PRO பெறுவதன் மதிப்பு",
  proWhyList: [
    "ஓட்டுநர் தேர்வுக்குத் தேவையான முழுமையான அறிவைப் பெறலாம்.",
    "5 லட்சத்திற்கும் மேற்பட்ட மாணவர்களின் தேர்ச்சிக்கு பங்களித்தது.",
    "ஆண்ட்ராய்டு மற்றும் iOS இல் முதன்மையான செயலியாகத் தேர்ந்தெடுக்கப்பட்டது.",
    "ஆயிரக்கணக்கான நேர்மறையான பயனர் மதிப்புரைகள்.",
  ],
}]